import { DatePipe, TitleCasePipe } from '@angular/common';
import { Component, ViewChild, inject } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { Guid } from 'guid-typescript';
import { ActivityLogModel } from 'src/app/models/activity-log.model';
import { ActivitiesLogsService } from 'src/app/services/activities-logs.service';
import { DetailAnimations } from 'src/app/shared/animations/container-animation';
import { CommonFunctionsConfiguratorService } from 'src/app/shared/services/swal-fire-configurator.service';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-activitiesLogs',
    templateUrl: './activities-logs.component.html',
    styleUrls: ['./activities-logs.component.scss'],
    animations: [DetailAnimations.height],
    imports: [MatProgressSpinner, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatIcon, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator]
})
export class ActivitiesLogsComponent {
  logSrv = inject(ActivitiesLogsService);
  datepipe = inject(DatePipe);
  private readonly paginatorService = inject(CommonFunctionsConfiguratorService);
  private readonly titlecasePipe = inject(TitleCasePipe);

  displayedColumns: string[] = ['createdOn', 'name', 'userName', 'icon'];
  dataSource!: MatTableDataSource<ActivityLogModel>;
  expandedElement!: ActivityLogModel | null;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  logs: ActivityLogModel[] = [];
  loading: boolean = false;

  constructor() {
    this.dataSource = new MatTableDataSource(this.logs);
  }

  transformName(value: any) {
    return this.titlecasePipe.transform(value);
  }

  getActivityLogs(taskId: Guid) {
    this.loading = true;
    this.logSrv.get(taskId).subscribe({
      next: (data: ActivityLogModel[]) => {
        this.logs = data;

        this.dataSource = new MatTableDataSource(this.logs);
        this.paginatorService.configurePaginator(
          this.dataSource,
          this.paginator,
          this.sort,
          "Registros"
        );

        this.loading = false;
      },
      error: (err) => {
        console.error(err);
        this.loading = false;
      },
    });
  }

  formatDate(date: any) {
    let ant = new Date(Date.parse(date));
    let localDate = new Date(
      ant.getUTCFullYear(),
      ant.getUTCMonth(),
      ant.getUTCDay(),
      ant.getUTCHours(),
      ant.getUTCMinutes() - new Date().getTimezoneOffset()
    );
    return this.datepipe.transform(localDate, 'dd/MM/YYYY HH:mm');
  }

  // Only activities with notes have something to expand.
  toggle(log: ActivityLogModel) {
    if (!log.notes) return;
    this.expandedElement = this.expandedElement === log ? null : log;
  }

  initials(name: string) {
    // An email is split by its local part ("ary.cometto@x.com" -> "AC"), a name by its words.
    const text = (name ?? '').trim();
    const separator = text.includes('@') ? /[._-]+/ : /\s+/;
    const parts = text.split('@')[0].split(separator).filter(Boolean);
    if (parts.length === 0) return '?';
    const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
    return (parts[0][0] + last).toUpperCase();
  }

  getDate(date: Date) {
    return this.datepipe.transform(date, 'dd/MM/yyyy - HH:mm');
  }
}
